// Generated file : do not modify
import Owner from '@/extend/classes/Owner';
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Adresses postales
export default class Adresse  {
  // Identifiant unique
  public id: number;
  // Adresse
  public adresse1: string;
  // Complément d'adresse
  public adresse2: string;
  // Code postal
  public codePostal: string;
  // Ville
  public ville: string;
  // Pays
  public paysId: number;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Client
  public clientId: number;
  // Type de notification
  public notifDefType: NotifDefTypes;
  // Objet à l'origine de la requête
  public owner: Owner;

  constructor() {
    this.id = 0;
    this.adresse1 = '';
    this.adresse2 = '';
    this.codePostal = '';
    this.ville = '';
    this.paysId = 0;
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.clientId = 0;
    this.notifDefType = NotifDefTypes.NONE;
    this.owner = new Owner();
  }

  public static fromJson (obj: Adresse): Adresse {
    const newAdresse: Adresse = new Adresse();
    newAdresse.id = obj.id;
    newAdresse.adresse1 = obj.adresse1;
    newAdresse.adresse2 = obj.adresse2;
    newAdresse.codePostal = obj.codePostal;
    newAdresse.ville = obj.ville;
    newAdresse.paysId = obj.paysId;
    newAdresse.createId = obj.createId;
    newAdresse.failed = obj.failed;
    newAdresse.canUpdate = obj.canUpdate;
    newAdresse.canDelete = obj.canDelete;
    newAdresse.display = obj.display;
    newAdresse.clientId = obj.clientId;
    newAdresse.notifDefType = obj.notifDefType;
    newAdresse.owner = JSON.parse(JSON.stringify(obj.owner));
    return newAdresse;
  }

  public toJsonAdresse (): string {
    const json = {
      adresse1: this.adresse1,
      adresse2: this.adresse2,
      codePostal: this.codePostal,
      ville: this.ville,
      paysId: this.paysId,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromAdresse (obj: Adresse): void {
    this.id = obj.id;
    this.adresse1 = obj.adresse1;
    this.adresse2 = obj.adresse2;
    this.codePostal = obj.codePostal;
    this.ville = obj.ville;
    this.paysId = obj.paysId;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.clientId = obj.clientId;
    this.notifDefType = obj.notifDefType;
    this.owner = obj.owner;
  }

  public compareAdresse (value: Adresse): boolean {
    return (this.toJsonAdresse() == value.toJsonAdresse());
  }

  public cloneAdresse (): Adresse {
    return Adresse.fromJson(this);
  }

  public createForStoreAdresse (): Promise<Adresse> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/adresses/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromAdresse(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreAdresse (): Promise<Adresse> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/adresses/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromAdresse(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreAdresse (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/adresses/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/adresses/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Adresses/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Adresse.fromJson(listData.reccords[0] as Adresse);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Adresse> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Adresses/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Adresse.fromJson(listData.reccords[0] as Adresse);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(adresses: Adresse[]) {
  }
}
